import type { GetImpactRatingsWithAppetitesResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactRatingsWithAppetitesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingsWithAppetitesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingsWithAppetitesArgs = {
  today: string;
};

export const useGetImpactRatingsWithAppetites = createQueryHook<
  UseGetImpactRatingsWithAppetitesArgs,
  GetImpactRatingsWithAppetitesResponseRow[],
  GetImpactRatingsWithAppetitesQuery
>({
  trpcQueryOptions: (trpc, { today }) =>
    trpc.frontend.impactRating.impactRatingsWithAppetites.queryOptions({
      today,
    }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingsWithAppetitesDocument,
  graphqlVariables: ({ today }) => ({ today }),
});
